export default "/static/dashboard/build/app/img/v2/6d6b0702dda87203891f0f86d164831b.png";